"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getExternalId: function getExternalId(key, organizations) {
        for (var i = 0, l = organizations.length; i < l; ++i) {
            if (!organizations[i]) continue;
            var externalIds = organizations[i].externalIds || {};
            var value = externalIds[key] || null;
            if (value !== null) {
                return value;
            }
        }
        return null;
    },
    getMessage: function getMessage(key, organizations, locale, defaultLocale) {
        var localized = [];
        _lodash2.default.each(organizations, function (organization) {
            if (!organization) return;
            localized.push(organization.messages || {});
        });

        var l = _lodash2.default.map(localized, key);
        return l[locale] || l[defaultLocale];
    },
    getMessageFromFull: function getMessageFromFull(key, full, locale, defaultLocale) {
        switch (full.type) {
            case "restaurant_full":
                return this.getMessage(key, [full.restaurant, full.chain, full.distributor], locale, defaultLocale);
            case "chain_full":
                return this.getMessage(key, [full.chain, full.distributor], locale, defaultLocale);
            case "portal_full":
                return this.getMessage(key, [full.portal, full.distributor], locale, defaultLocale);
            default:
                return this.getMessage(key, [full], locale, defaultLocale);
        }
    },
    getAppsFromFull: function getAppsFromFull(full, type) {
        var appsByPlatform = {};

        _lodash2.default.each([full.chain, full.restaurant, full.portal], function (organization) {

            _lodash2.default.each((organization || {}).apps || [], function (app) {
                if (app.type !== type) return;

                appsByPlatform[app.platform] = app;
            });
        });

        return _lodash2.default.values(appsByPlatform);
    },
    getOrganizationFromFull: function getOrganizationFromFull(full) {
        return full.restaurant || full.chain || full.portal || full.affiliate || full.distributor || full;
    },
    getDistributorId: function getDistributorId(organization) {
        if (!organization) {
            return "openrest.com";
        }

        switch (organization.type) {
            case "restaurant": // Fall through
            case "chain": // Fall through
            case "portal":
                // Fall through
                return organization.distributorId;
            case "distributor":
                return organization.id;
            default:
                throw new Error("Unknown organization type: " + organization.type);
        }
    },
    getBeepUrls: function getBeepUrls(organizations) {
        var beepUrls = {};
        _lodash2.default.chain(organizations).compact().reverse().each(function (organization) {
            beepUrls.wav = beepUrls.wav || (organization.media || {})["beep.wav"] || null;
            beepUrls.mp3 = beepUrls.mp3 || (organization.media || {})["beep.mp3"] || null;
            beepUrls.ogg = beepUrls.ogg || (organization.media || {})["beep.ogg"] || null;
        });
        return beepUrls;
    },
    getBeepUrlsFromFull: function getBeepUrlsFromFull(full) {
        switch (full.type) {
            case "restaurant_full":
                return this.getBeepUrls([full.restaurant, full.chain, full.distributor]);
            case "chain_full":
                return this.getBeepUrls([full.chain, full.distributor]);
            case "portal_full":
                return this.getBeepUrls([full.portal, full.distributor]);
            default:
                return this.getBeepUrls([full]);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/Full.js
// module id = 1125
// module chunks = 0